export const removeEmptyObjectValues = <T extends Record<string, unknown>>(object: T): Partial<T> => {
  const newObject: Partial<T> = {};
  for (const [key, value] of Object.entries(object) as [keyof T, T[keyof T]][]) {
    if (value !== null && value !== undefined && value !== '') {
      newObject[key] = value;
    }
  }
  return newObject;
};